import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from './Constants.js';
import { Spinner } from 'react-bootstrap';

const Get_Return_Stock = () => {
  const [stocks, setStocks] = useState([]);
  const [sizesMap, setSizesMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [formError, setFormError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchReturnStock = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const response = await fetch(`${BASE_URL}get_return_stock/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (data.status && data.data) {

          const record = data.data;

          const sizes = await fetchSizesByType(record.dresstype_id, token);

          setSizesMap({
            0: sizes,
          });

          setStocks([
            {
              ...record,

              // Existing values
              existing_dress_size: record.dresssize_id,
              dress_size: record.new_dresssize_id,

              // Existing color & quantity
              new_dress_color_id: record.new_dresscolor_id,
              new_quantity: record.avl_qty,
            },
          ]);

        } else {
          setStocks([]);
        }

      } catch (err) {
        console.error("Return stock fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchReturnStock();
  }, [id]);

  const fetchSizesByType = async (typeId, token) => {
    try {
      const res = await fetch(`${BASE_URL}dress_sizes_by_type`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ type_id: typeId }),
      });
      const data = await res.json();
      return data.dressTypes || [];
    } catch (err) {
      console.error(`Size fetch error for type ${typeId}:`, err);
      return [];
    }
  };

  const handleSizeChange = async (index, selectedSizeId) => {
    if (!selectedSizeId) return;

    try {
      const token = localStorage.getItem('authToken');
      const typeId = stocks[index].dress_type_id;
      const gender = stocks[index].gender;
      const area = stocks[index].area_id;

      const colorRes = await fetch(`${BASE_URL}getNewDressColorId`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          size_id: selectedSizeId,
          type_id: typeId,
          gender: gender,
          area_id: area,
        }),
      });

      const colorData = await colorRes.json();

      // Safely extract color ID and quantity from response
      const newColorId = colorData?.data?.id?.[0]?.id || '';
      const newQuantity = colorData?.data?.qty?.[0]?.quantity || '';

      const updatedStocks = [...stocks];
      updatedStocks[index] = {
        ...updatedStocks[index],
        dress_size: selectedSizeId,
        new_dress_color_id: newColorId,
        new_quantity: newQuantity, // optional: only if you need it
      };

      setStocks(updatedStocks);
      setFormError(null);
    } catch (error) {
      console.error('Error fetching new dress color ID:', error);
      setFormError('Failed to fetch updated dress color.');
    }
  };





  const handleSubmit = async (index) => {
    const item = stocks[index];
    if (!item.dress_size) {
      setFormError('Please select a new dress size.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('area_id', item.area_id);
      formData.append('gender', item.gender);
      formData.append('type_id', item.dresstype_id);
      formData.append('old_dress_color_id', item.dresscolor_id);
      formData.append('old_dress_size_id', item.dresssize_id);
      formData.append('new_dress_color_id', item.new_dress_color_id);
      formData.append('new_dress_size_id', item.dress_size);

      const response = await fetch(`${BASE_URL}return_stock/${item.stock_id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });

      const result = await response.json();
      if (result.status) {
        navigate('/manage_return_stock');
      } else {
        setFormError('Failed to update stock.');
      }
    } catch (error) {
      console.error(error);
      setFormError('Error updating stock.');
    }
  };

  const handleBackClick = () => navigate('/manage_return_stock');
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  if (loading) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>;
  }

  return (
    <div className="page-wrapper" style={{ height: '100vh', overflow: 'hidden' }}>
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content flex-grow-1" style={{ overflow: 'auto' }}>
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="col-lg-12">
                <div className="card shadow-sm border-0">
                  <div className="card-header bg-white">
                    <h4 className="mb-0 text-primary">Return Stock</h4>
                  </div>
                  <div className="card-body">
                    {formError && <div className="alert alert-danger small">{formError}</div>}

                    <div className="row">
                      {stocks.map((stock, index) => (
                        <div className="col-md-6 mb-4" key={index}>
                          <form
                            onSubmit={(e) => { e.preventDefault(); handleSubmit(index); }}
                            className="d-flex flex-column h-100 border rounded bg-light shadow-sm p-3"
                            style={{ minHeight: '500px', fontSize: '0.875rem' }}
                          >
                            {/* Scrollable content */}
                            <div className="flex-grow-1 overflow-auto pe-1">
                              <h6 className="text-secondary mb-3">#{index + 1} - {stock.dress_type}</h6>

                              {[['Candidate Name', stock.candidate_name],
                              ['Mobile', stock.mobile],
                              ['Date of Join', stock.date_of_join],
                              ['Department', stock.department],
                              ['Location', stock.area],
                              ['Gender', stock.gender],
                              ['Dress Type', stock.dress_type],
                              ['Dress Type Id', stock.dresstype_id],
                              ['Dress Color', stock.dress_color],
                              ['Dress Color Id', stock.dresscolor_id],
                              ['Uniform Qty', stock.uniform_qty],
                              ['Area', stock.area],
                              ['Dress Size Id', stock.dresssize_id],
                              ].map(([label, value], i) => (
                                <div className="form-group mb-2" key={i}>
                                  <label className="form-label small mb-1">{label}</label>
                                  <input type="text" className="form-control form-control-sm" value={value} readOnly />
                                </div>
                              ))}

                              <div className="form-group mb-2">
                                <label className="form-label small mb-1">Existing Size</label>
                                <select className="form-control form-control-sm" value={stock.existing_dress_size} disabled>
                                  <option value="">Select Size</option>
                                  {(sizesMap[index] || []).map(size => (
                                    <option key={size.id} value={size.id}>{size.dress_size}</option>
                                  ))}
                                </select>
                              </div>

                              <div className="form-group mb-3">
                                <label className="form-label small mb-1">New Dress Size</label>
                                <select
                                  className="form-control form-control-sm"
                                  name="dress_size"
                                  value={stock.dress_size}
                                  onChange={(e) => handleSizeChange(index, e.target.value)}
                                  disabled
                                >
                                  <option value="">Select Size</option>
                                  {(sizesMap[index] || []).map(size => (
                                    <option key={size.id} value={size.id}>{size.dress_size}</option>
                                  ))}
                                </select>
                              </div>

                              {/* New fields to display selected size and new dress color */}
                              <div className="form-group mb-2">
                                <label className="form-label small mb-1">Selected New Dress Size ID</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={stock.dress_size || ''}
                                  disabled
                                />
                              </div>

                              
                                  <div className="form-group mb-2">
                                    <label className="form-label small mb-1">New Dress Color ID</label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={stock.new_dress_color_id || ""}
                                      readOnly
                                    />
                                  </div>

                                  <div className="form-group mb-2">
                                    <label className="form-label small mb-1">Available Quantity</label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={stock.new_quantity || ""}
                                      readOnly
                                    />
                                  </div>
                                
                            </div>

                            {/* Sticky action buttons */}
                            <div className="mt-3 d-flex justify-content-between border-top pt-2">
                              <button type="submit" className="btn btn-sm btn-primary px-3">Update</button>
                              <button type="button" className="btn btn-sm btn-secondary px-3" onClick={handleBackClick}>Cancel</button>
                            </div>
                          </form>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Get_Return_Stock;
